/**
 * Smoothly scrolls to an element by id, preferring the active Lenis instance
 * (so it matches the page's inertia scrolling) and falling back to native
 * smooth scroll when Lenis isn't available (e.g. reduced motion).
 */
export function scrollToId(id: string, offset = -80) {
  if (typeof window === "undefined") return;
  const el = document.getElementById(id);
  if (!el) return;
  const lenis = (
    window as unknown as {
      __lenis?: { scrollTo: (t: Element, o?: { offset?: number }) => void };
    }
  ).__lenis;
  if (lenis) lenis.scrollTo(el, { offset });
  else el.scrollIntoView({ behavior: "smooth" });
}
